import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { verifyToken } from '../../Services/Login/LoginApi'; // API to verify token

const AutoLogin = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('Processing...');
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {
        const token = searchParams.get('token');

        if (!token) {
            setStatus('Invalid link.');
            setIsExpired(true);
            return;
        }

        const verify = async () => {

            try {
                const response = await verifyToken(token);

                if (!response?.code?.includes("ERR")) {
                    const { redirectUrl } = response;
                    let seekerId = null;
                    let userType = null;

                    if (response.student?.id) {
                        seekerId = response.student.id;
                        userType = "student";
                    } else if (response.seeker?.id) {
                        seekerId = response.seeker.id;
                        userType = "seeker";
                    }

                    localStorage.setItem("Type", userType);
                    localStorage.setItem("seekerId", seekerId);

                    // ✅ Set access flag for reset-password
                    sessionStorage.setItem("allowResetPassword", "true");

                    navigate(redirectUrl);
                }
                else {
                    setStatus(response.response?.data?.error || response.response?.data?.message || 'Expired Token.');
                    setIsExpired(true);
                }
            } catch (err) {
                if (err.response?.status === 401 && err.response?.data?.provider) {
                    setStatus(`Please sign in with SSO: ${err.response.data.provider}`);
                } else {
                    setStatus(err.response?.data?.error || err.response?.data?.message || 'Expired Token.');
                    setIsExpired(true);
                }
            }
        };

        verify();
    }, [navigate, searchParams]);

    return (
        <div className="d-flex flex-column justify-content-center align-items-center text-center" style={{ minHeight: '100vh', padding: '20px' }}>
            <h3>{status}</h3>
            {isExpired && (
                <Link to="/forget-password" style={{ fontSize: '18px', marginTop: '15px', color: '#007bff', textDecoration: 'underline' }}>
                    Please click here to request a new password reset link
                </Link>
            )}
        </div>
    );
};

export default AutoLogin;
